import { shortDateFormatter } from "../../gridFormatters";

export const databaseVersionDefs = [
    	{
		field: "collection_date",
		headerName: "Collection Date",
		cellRenderer: shortDateFormatter
	},
  	{
		field: "database_server_ip",
		headerName: "Server IP Address",
	},
	{
		field: "instance_name",
		headerName: "Instance Name",
	},
	{
		field: "device_type_description",
		headerName: "Database Type",
	},
	{
		field: "version_full",
		headerName: "Version",
	},
]

